import { getFkText } from './chartFormats';

const SCALE_STOPS = {
    redGreen: [
        { pos: 0,   rgb: [217, 83, 79] },
        { pos: 0.5, rgb: [240, 173, 78] },
        { pos: 1,   rgb: [92, 184, 92] }
    ],
    mono: [
        { pos: 0, rgb: [240, 240, 240] },
        { pos: 1, rgb: [90, 90, 90] }
    ]
};

export function computeColumnStats(rows, columns) {
    let stats = {};
    if (!Array.isArray(columns)) return stats;

    columns.forEach(col => {
        let kind = col && col.cond && col.cond.kind;
        if (!kind || kind === 'none') return;
        if (!col.field) return;

        let min = null, max = null, count = 0;
        rows.forEach(row => {
            let fk = getFkText(row, col.field);
            if (fk != null) return;
            let val = row.get(col.field);
            if (val == null || val === '') return;
            let n = typeof val === 'number' ? val : Number(val);
            if (isNaN(n)) return;
            if (min == null || n < min) min = n;
            if (max == null || n > max) max = n;
            count++;
        });
        stats[col.field] = { min, max, count };
    });

    return stats;
}

export function applyConditional(td, rawValue, displayText, col, stats) {
    let cond = col && col.cond;
    let kind = cond && cond.kind;
    if (!kind || kind === 'none') return false;
    let n = typeof rawValue === 'number' ? rawValue : Number(rawValue);
    if (rawValue == null || rawValue === '' || isNaN(n)) return false;

    let st = stats && stats[col.field];
    let min = cond.min != null && cond.min !== '' ? Number(cond.min) : (st ? st.min : null);
    let max = cond.max != null && cond.max !== '' ? Number(cond.max) : (st ? st.max : null);
    if (min == null || max == null || isNaN(min) || isNaN(max)) return false;

    let range = max - min;
    let t = range > 0 ? (n - min) / range : 0;
    if (t < 0) t = 0;
    if (t > 1) t = 1;

    switch (kind) {
        case 'dataBar':    return _renderDataBar(td, displayText, t, cond);
        case 'colorScale': return _renderColorScale(td, displayText, t, cond);
        case 'iconSet':    return _renderIconSet(td, displayText, t, cond);
        default: return false;
    }
}

function _renderDataBar(td, text, t, cond) {
    let color = (cond && cond.barColor) || 'theme';

    let wrap = document.createElement('div');
    wrap.className = 'xp-grid-chart-bar-wrap';

    let bar = document.createElement('div');
    bar.className = 'xp-grid-chart-bar xp-grid-chart-bar-' + color;
    bar.style.width = (t * 100).toFixed(2) + '%';
    wrap.appendChild(bar);

    let value = document.createElement('span');
    value.className = 'xp-grid-chart-bar-value';
    value.textContent = text;
    wrap.appendChild(value);

    td.appendChild(wrap);
    td.classList.add('has-bar');
    return true;
}

function _renderColorScale(td, text, t, cond) {
    let palette = (cond && cond.palette) || 'theme';
    if (palette === 'theme') {
        let alpha = 0.10 + t * 0.70;
        td.style.background = 'rgba(var(--theme-primary-700-rgb, 0,0,0),' + alpha.toFixed(3) + ')';
        if (t > 0.55) td.style.color = '#fff';
    } else {
        let stops = SCALE_STOPS[palette] || SCALE_STOPS.mono;
        let rgb = _interpRgb(stops, t);
        td.style.background = 'rgb(' + rgb[0] + ',' + rgb[1] + ',' + rgb[2] + ')';
        if (palette === 'mono' && t > 0.55) td.style.color = '#fff';
    }
    td.textContent = text;
    return true;
}

function _renderIconSet(td, text, t, cond) {
    let set = (cond && cond.iconSet) || 'traffic';
    let level = t < 1 / 3 ? 'low' : (t < 2 / 3 ? 'mid' : 'high');

    let icon = document.createElement('span');
    icon.className = 'xp-grid-chart-icon xp-grid-chart-icon-' + set + ' is-' + level;
    if (set === 'arrows') {
        icon.textContent = level === 'low' ? '↓' : (level === 'mid' ? '→' : '↑');
    } else if (set === 'check') {
        icon.textContent = level === 'low' ? '✗' : (level === 'mid' ? '!' : '✓');
    }

    let value = document.createElement('span');
    value.className = 'xp-grid-chart-icon-value';
    value.textContent = text;

    td.appendChild(icon);
    td.appendChild(value);
    td.classList.add('has-icon');
    return true;
}

function _interpRgb(stops, t) {
    if (t <= stops[0].pos) return stops[0].rgb;
    if (t >= stops[stops.length - 1].pos) return stops[stops.length - 1].rgb;
    for (let i = 0; i < stops.length - 1; i++) {
        let a = stops[i], b = stops[i + 1];
        if (t >= a.pos && t <= b.pos) {
            let u = (t - a.pos) / (b.pos - a.pos);
            return [
                Math.round(a.rgb[0] + (b.rgb[0] - a.rgb[0]) * u),
                Math.round(a.rgb[1] + (b.rgb[1] - a.rgb[1]) * u),
                Math.round(a.rgb[2] + (b.rgb[2] - a.rgb[2]) * u)
            ];
        }
    }
    return stops[stops.length - 1].rgb;
}
